import { lazyWithRetry } from '@lon/shared/utils';

const ForgotPassword = lazyWithRetry(
  () => import('./ForgotPassword'),
  'ForgotPassword'
);

export { ForgotPassword };
